import { Container } from "@mui/material";
import { Navigate } from "react-router-dom";
import AppLayout from "../AppLayout/AppLayout";
import { FormStepper } from "../Development/pages";
import ViewProject from "../Development/pages/ViewProject";
export const issuesRoutes = [
  {
    path: "/board",
    element: (
      <AppLayout>
        <Container>Coming soon</Container>
      </AppLayout>
    ),
  },
  {
    path: "/projects",
    element: <Navigate to="/works" replace />,
  },
  {
    path: "/project",
    element: (
      <AppLayout>
        <FormStepper />
      </AppLayout>
    ),
  },
  {
    path: "/project/:projectNumber",
    element: (
      <AppLayout>
        <ViewProject />
      </AppLayout>
    ),
  },
];
